import React from 'react';
import { Card } from '../ui/Card';
import { tables } from '../../data/mockData';
import SafeIcon from '../../common/SafeIcon';
import { FiClock, FiUser } from 'react-icons/fi';

export const ReservationsList = () => {
  const reservations = tables.filter(t => t.status === 'reserved').sort((a, b) => a.reservationTime.localeCompare(b.reservationTime));

  return (
    <Card title="Upcoming Reservations" className="col-span-1">
      <div className="relative border-l border-chefPanel ml-3 space-y-6">
        {reservations.map((res, idx) => (
          <div key={idx} className="relative pl-6">
            {/* Timeline dot */}
            <div className="absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full bg-status-reserved ring-4 ring-chefDark" />
            
            <div className="bg-chefBlack p-3 rounded border border-chefPanel">
              <div className="flex justify-between items-start mb-2">
                <span className="text-receiptWhite font-medium">{res.name} Party</span>
                <span className="text-status-reserved font-mono text-xs bg-status-reserved/10 px-2 py-0.5 rounded">
                  {res.reservationTime}
                </span>
              </div>
              <div className="flex gap-4 text-xs text-receiptMuted font-mono">
                <span className="flex items-center gap-1"><SafeIcon icon={FiUser} className="w-3 h-3"/> {res.capacity} pax</span>
                <span className="flex items-center gap-1"><SafeIcon icon="Hash" className="w-3 h-3"/> {res.id}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};